export default __webpack_public_path__ + "static/media/Snd_CJ.1283d4a0.mp3";